import config from '../../config.json';

const baseUrl = config.SERVER_URL;

export const LoginUrl = baseUrl + 'login';
export const productsListUrl = baseUrl + 'backoffice/products';
export const addProductUrl = baseUrl + 'backoffice/products/create';
export const editProductUrl = baseUrl + 'backoffice/products/update';
export const addVariantUrl = baseUrl + 'backoffice/product/variants/create';
export const editVariantUrl = baseUrl + 'backoffice/product/variants/update';
export const showVariantUrl = baseUrl + 'backoffice/product/variants';
export const categoriesUrl = baseUrl + 'backoffice/categories';
export const pricesUrl = baseUrl + 'backoffice/prices';
export const MediaListUrl = baseUrl + 'backoffice/files/list';
export const MediaUploadUrl = baseUrl + 'backoffice/files/upload';
export const MediaFileUrl = baseUrl + 'backoffice/files';
export const ordersUrl = baseUrl + 'backoffice/orders';
export const operatorsUrl = baseUrl + 'backoffice/operators';
export const transactionsUrl = baseUrl + 'backoffice/payments';
export const descriptionsUrl = baseUrl + 'backoffice/descriptions';
export const collectionsUrl = baseUrl + 'backoffice/collections';
export const productCarouselsUrl = baseUrl + 'backoffice/product-carousels';
export const campaignsUrl = baseUrl + 'backoffice/campagnes';
export const usersUrl = baseUrl + 'backoffice/users';
export const adminsUrl = baseUrl + 'backoffice/admins';
export const permissionsUrl = baseUrl + 'backoffice/permissions';
export const profileUrl = baseUrl + 'backoffice/profile';
export const branchesUrl = baseUrl + 'backoffice/branches';
export const contactsUrl = baseUrl + 'backoffice/contact-us';
export const branchRequestsUrl = baseUrl + 'backoffice/branch-requests';
export const jobsUrl = baseUrl + 'backoffice/resumes';
export const eventsUrl = baseUrl + 'backoffice/calendar';
export const pagesUrl = baseUrl + 'backoffice/pages';
export const settingsUrl = baseUrl + 'backoffice/settings';
export const slidersUrl = baseUrl + 'backoffice/sliders';
export const faqsUrl = baseUrl + 'backoffice/faqs';
export const discountGroupsUrl = baseUrl + 'backoffice/categories-discount';
export const cityUrl = baseUrl + 'city';
export const shiptimesUrl = baseUrl + 'backoffice/submission-times';
export const couponsUrl = baseUrl + 'backoffice/coupons';
export const postsUrl = baseUrl + 'backoffice/blog/posts';
export const postsCategoriesUrl = baseUrl + 'backoffice/blog/categories';
export const packagesUrl = baseUrl + 'backoffice/packaging';
export const gatewaysUrl = baseUrl + 'backoffice/payment-gateways';
export const appLogsUrl = baseUrl + 'backoffice/app-logs';
